import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./global_styling/index.scss";

ReactDOM.render(<App />, document.getElementById("root"));
